var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c("cargo-advance-select", {
        attrs: {
          "select-type": _vm.TYPE_NAMES.basic_data_CargoInformation,
          disabled: _vm.disabled,
          filterable: "",
          clearable: true,
          "default-value": _vm.job.cargoCode,
          "allow-create": false
        },
        on: {
          parentCallBack: function(p) {
            _vm.job.cargoCode = p.value
            _vm.onChange("cargoCode")
          }
        }
      }),
      _c("el-input", {
        staticStyle: { "margin-top": "5px" },
        attrs: { disabled: _vm.disabled || !_vm.job.cargoCode },
        on: {
          change: function($event) {
            return _vm.onChange("cargoName")
          }
        },
        model: {
          value: _vm.job.cargoName,
          callback: function($$v) {
            _vm.$set(_vm.job, "cargoName", $$v)
          },
          expression: "job.cargoName"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }